export const OTHER = "Other";
export const STATE = "state";
export const EVRYSDI = "Evrysdi";
export const ELIGIBILITY_QUESTIONNAIRE_FIELD_NAME = "eligibilityQuestionnaire";

export const ProviderTypes = Object.freeze({ Physician: "Physician", Facility: "Facility" });
export const PhoneNumberType = Object.freeze({ HOME: "home", MOBILE: "mobile" });

export const PEMFEXY_DEFAULT_NDC = "42367-0531-33";
export const HEADER_SUBMIT_BUTTON_TYPES = Object.freeze({
  COMPLETE_FORM: "Complete Form",
  SUBMIT_FORM: "Submit Form",
  GENERATE_PDF: "Generate PDF"
});

export const FORM_FIELD_TYPES = Object.freeze({
  PHONE: "phone",
  LANGUAGE: "language",
  STATE: "state",
  INPUT: "input",
  MULTIPLIER: "fieldMultiplier",
  SINGLE_SELECT: "singleSelect",
  GENDER: "gender",
  CHECKBOX: "checkbox",
  RADIO: "radio",
  RADIO_CAREGIVER: "caregiverRadio"
});

export const getHeaderSubmitButtonText = (headerSubmitButtonType) => {
  if (!headerSubmitButtonType) {
    return "application_form_editor.genentech.copay.submit_button";
  }

  const buttonText = {
    [HEADER_SUBMIT_BUTTON_TYPES.COMPLETE_FORM]: "application_form_editor.eagle.complete_button",
    [HEADER_SUBMIT_BUTTON_TYPES.SUBMIT_FORM]: "application_form_editor.genentech.copay.submit_button",
    [HEADER_SUBMIT_BUTTON_TYPES.GENERATE_PDF]: "application_form_editor.regeneron.generate_pdf_button"
  };

  return buttonText[headerSubmitButtonType];
};

export const EE_ERROR_MESSAGES = Object.freeze({
  PRACTICE_NOT_REGISTERED: "Practice not registered",
  PATIENT_ALREADY_ENROLLED: "Patient is already enrolled",
  PATIENT_HAS_GOVERNMENT_INSURANCE: "Patient has government insurance"
});
